import { render, staticRenderFns } from "./FiltersComponent.vue?vue&type=template&id=936fe5d8&scoped=true&"
import script from "./FiltersComponent.vue?vue&type=script&lang=ts&"
export * from "./FiltersComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936fe5d8",
  null
  
)

export default component.exports